import { Component } from '@angular/core';

@Component({
    selector: 'update-mfa-enrollment-modal',
    template: `
        <div>
            <p class="body">
                We’ve noticed that you used a single-use backup code to sign into your account.
                Please click the button below to re-enroll with Duo Mobile.
            </p>
        </div>
    `
})
export class UpdateMfaEnrollmentModalComponent {}
